

















import { Vue, Component, Prop } from "vue-property-decorator";
import { Moment } from "moment";

@Component
export default class Datetime extends Vue {
  // Props

  @Prop({ required: true })
  public datetime!: Date | string;

  @Prop({ required: false, default: "" })
  public endOf!: moment.unitOfTime.StartOf;

  @Prop({ required: false, default: "" })
  public startOf!: moment.unitOfTime.StartOf;

  @Prop({ default: "span" })
  public type!: string;

  @Prop({ required: false, default: false })
  public showTextIfInvalid!: string;

  @Prop({ required: false, default: "" })
  public format!: string;

  @Prop({ required: false, default: "from" })
  public formatFunction!: string;

  @Prop({ default: undefined })
  public formatFunctionParams!: any;

  @Prop({ default: false })
  public enforceTooltip!: string;

  @Prop({
    required: false,
    default() {
      return (this as Vue).$t("_.na");
    }
  })
  public textIfInvalid!: string;

  @Prop({ required: false, default: "is-top" })
  public tooltipPosition!: string;

  // Data
  public momentDate: Moment = {} as Moment;
  // Lifecyle methods
  public created() {
    this.momentDate = this.$moment.utc(this.datetime).local();
  }
  // Computed
  public get wrapper() {
    if (!this.enforceTooltip && this.format) return null;
    return {
      type: "b-tooltip",
      props: {
        label: this.momentDate.format(
          (this.dateHasTime
            ? this.$t("_datetime.datetime.long")
            : this.$t("_datetime.date.long")) as string
        ),
        position: this.tooltipPosition,
        type: "is-dark"
      }
    };
  }

  public get dateHasTime() {
    return typeof this.datetime === "string"
      ? !!this.datetime.match(/\s\d{2}:\d{2}:\d{2}?$/)
      : true;
  }

  public get formatParams() {
    if (this.formatFunctionParams) return this.formatFunctionParams;
    switch (this.formatFunction) {
      case "calendar":
        return this.$store.getters["utils/time/formatFunctionCalendar"](
          this.datetime,
          {
            sameElse: now => {
              return `[${this.momentDate.from(now)}]`;
            }
          }
        );
      default:
        return undefined;
    }
  }
}
